/* global $:true */
import debug from 'debug';

import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '[data-ajax-save-on-change]';
const PLUGIN_NAME = 'ajaxSaveOnChange';
const MODULE_NAME = 'app.core/modules/ajax-save-on-change';
const log = debug(MODULE_NAME);

log('registerd');


function getOtherInputData(inputs) {
	return inputs.reduce(function (data, input) {
		return Object.assign({}, data, getInputValue(input));
	}, {});
}

function getInputValue(element) {
	if (!element.name || !element.value) {
		return false;
	}
	return {
		[element.name]: element.value,
	};
}

function paramatise(obj) {
	return Object.entries(obj)
		.map(([key, val]) => `${key}=${val}`)
		.join('&');
}


class AjaxSaveOnChange {
	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.value = this.$element.val();
		this.initial = this.value;

		/*
		Note this module differs from ajax-save-on-check
		in that it uses a DEFAULT value for the endpointParam
		Not the assigned input name
		*/

		/*
		other input elements whose name=value
		are to be added to the post query parmas
		in addition to the imput targetted by this module
		*/
		this.paramInputs = [
			...document.querySelectorAll(this.options.paramInputSelector),
		].filter((x) => {
			return x;
		});

		this.endpointUrl = $(
			`meta[name="site.${this.$element.attr(
				this.options.endpointMethodAttr
			)}"]`
		).attr('content');
		this.$element.on('change', this.change.bind(this));

		log('AjaxSaveOnChange', element, options);
	}

	change() {
		this.value = this.$element.val();
		log('change', this.$element, this.value, this.initial);

		if (this.isDirty) {
			this.submit();
		}
	}

	get isDirty() {
		const yesno = this.initial !== this.value;
		log('isDirty', this.$element, yesno);

		return yesno;
	}

	submit() {
		this.inputValue = this.value;
		log('submitted', this.$element);
		this.$element.attr('disabled', 'disabled');
		this.post();
	}

	onSuccess(result) {
		this.$element.removeAttr('disabled');

		if (typeof result.Success !== 'undefined' && result.Success) {
		} else {
			var errorList =
				typeof result.ValidationMessages !== 'undefined'
					? result.ValidationMessages
					: Array();
			log('ajaxSaveOnChangeServerError', errorList);
			this.$element.val(this.initial);
		}
	}

	getAntiForgeryToken() {
		return $(
			'#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]'
		).val();
	}

	post() {
		/* 1: this would be a good point to urlencode the text value!
			check that the back end will handle it appropriately first!
		*/
		const paramData = Object.assign(
			{
				[this.options.endpointParam]: this.inputValue, // 1
			},
			getOtherInputData(this.paramInputs)
		);

		const url = `${this.endpointUrl}?${paramatise(paramData)}`;

		const verificationData = {
			__RequestVerificationToken: this.getAntiForgeryToken(),
		};

		log('accepting', this.$element, url);
		$.ajax({
			url,
			method: 'post',
			data: verificationData,
			success: (result) => {
				this.onSuccess(result);
			},
			error: (e) => {
				log('ajaxSaveOnChangeAjaxError', e);
				this.$element.removeAttr('disabled');
				this.$element.val(this.initial);
			},
		}).done(() => {
			log('accepted', this.$element, url);
		});
	}
}

AjaxSaveOnChange.DEFAULTS = {
	endpointMethodAttr: 'data-endpoint-method',
	endpointParam: 'notes',
	submitErrorClassname: 'submit-error',
};

plugin(PLUGIN_NAME, AjaxSaveOnChange);

export function exec() {
	$(document).ready(() => {
		$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
	});
}



// WEBPACK FOOTER //
// ./client/src/core/modules/ajax-save-on-change/index.js